export default __webpack_public_path__ + "static/media/mute-video-off.41b72606.svg";